import axios from 'axios';

const http = axios.create({
  // baseURL: baseUrl,
  crossdomain: true,
});

http.interceptors.request.use(function (config) {
  config.url = `${
    window.__APP__.SVC_URL_API ||
    process.env.SVC_URL_API ||
    'https://api.local.dpty.io/url/v1'
  }/${config.url}`;
  return config;
});

export default http;
export { http };
